import { Component } from "@angular/core";

@Component({
  selector: "lib-success-icon",
  template: `<i class="ph ph-check bg-green text-white text-l font-black rounded-full w-6 h-6 flex items-center justify-center"></i>`,
  styles: [':host { display: inline-block; }']
})
export class SuccessIconComponent {}
